export enum NumberOfCorrectAnswersMode {
  X_OF_Y = 'x_of_y',
  PERCENTAGE = 'percentage'
}
